<template>
  <div class="container">
    <pfx-admin-menu />
    <div>
      <v-data-table :headers="headers" :pagination.sync="pagination" :items="users" must-sort hide-actions item-key="userId">
        <template slot="no-data">
          No users found
        </template>
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="viewUser(props.item.userId)">
            <td>
              {{ props.item.injected.profile.firstName }} {{ props.item.injected.profile.lastName }}
            </td>
            <td>
              {{ props.item.created | prettyDate }}
            </td>
            <td>
              {{ props.item.userId }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <br/>
      <div class="clearfix" style="text-align: center; margin: 2rem auto 0; max-width: 500px;">
        <p>
          <small>
            Assign new PFX admin user by typing the User ID to the field below.
            User ID is in UUID format, e.g. 68323bac-2140-11e8-9752-b75c3c4b865c
          </small>
        </p>
        <form ref="addAdminForm">
          <div class="add-textfield">
            <input type="text" placeholder="User ID" v-model="addAdminUserId" required pattern="[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}" />
          </div>
          <div class="add-button">
            <button @click.prevent="addAdmin"><v-icon dark>person_add</v-icon> Add new admin</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import PfxAdminMenu from './PfxAdminMenu.vue'
  import { mapMutations } from 'vuex'

  export default {
    name: 'PfxAdminUsers',
    components: {
      PfxAdminMenu
    },
    data() {
      return {
        users: [],
        headers: [
          { text: 'Name', align: 'left', value: 'injected.profile.lastName' },
          { text: 'Created', align: 'left', value: 'created' },
          { text: 'User ID', align: 'left', value: 'userId' }
        ],
        pagination: {
          sortBy: 'injected.profile.lastName', descending: false, rowsPerPage: 100000000
        },
        addAdminUserId: ''
      }
    },
    created() {
      this.loadUsers()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      loadUsers() {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi.getPfxAdminUsers().then(res => {
          console.log('getPfxAdminUsers res', res)
          const users = res.data || []
          users.forEach(user => {
            user.injected = {}
            user.injected.profile = {}

            this.$PfxBackendApi.getUser(user.userId).then(res => {
              console.log('getUser res', res)
              user.injected.profile = res.data || {}
            }).catch(err => {
              console.error('getUser err', err)
            })
          })
          this.users = users
        }).catch(err => {
          console.error('getPfxAdminUsers err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading users' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.setLoadingSpinner(false))
      },

      viewUser(userId) {
        this.$router.push('/pfxadmin/users/' + userId)
      },

      addAdmin() {
        if (!this.$refs.addAdminForm.checkValidity()) {
          this.$refs.addAdminForm.reportValidity()
          return
        }

        this.$PfxBackendApi.addPfxAdminUser(this.addAdminUserId).then(res => {
          console.log('addPfxAdminUser res', res)
          this.$notify({ type: 'info', message: 'New PFX admin added' })
          this.addAdminUserId = ''
          this.loadUsers()
        }).catch(err => {
          console.error('addPfxAdminUser err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during add admin' })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .add-textfield, .add-button {
    margin-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/PfxAdminUsers.vue